import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../../assets/css/Certificate/Certificate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faDownload,
  faTimes,
  faShareAlt,
} from "@fortawesome/free-solid-svg-icons";
import { BASE_URL } from "../../store/config";
 
function Certificate() {
  const [certificates, setCertificates] = useState([]);
  const [selectedCert, setSelectedCert] = useState(null);
  const [shareCert, setShareCert] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
 
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("date-desc");
  const token = localStorage.getItem("access_token")?localStorage.getItem("access_token") : localStorage.getItem("accessToken");
 
 
  /* ================= FETCH CERTIFICATES ================= */
useEffect(() => {
  const fetchCertificates = async () => {
    try {
      const token =
        localStorage.getItem("access_token") ||
        localStorage.getItem("accessToken");
       
      if (!token) {
        navigate("/login");
        return;
      }
 
      console.log("token from front end",token)
      const res = await fetch(`${BASE_URL}api/user-certificates`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
 
 
      // ❗ HANDLE UNAUTHORIZED PROPERLY
      if (res.status === 401) {
        localStorage.clear();
        navigate("/login");
        return;
      }
 
      const data = await res.json();
 
      if (!res.ok) {
        throw new Error(data?.message || "Request failed");
      }
 
      if (data.status === "success") {
        const formattedData = data.certificates.map((cert) => ({
          id: cert.id,
          title: cert.course_name,
          dateRaw: cert.issued_at,
          date: cert.issued_at
            ? new Date(cert.issued_at).toLocaleDateString()
            : "N/A",
          issuedBy: "SSDN Technologies",
          image: cert.image_url,
          fileUrl: cert.pdf_url,
          status: cert.status,
          publicUrl: `${BASE_URL}api/public-certificate/${cert.id}`,
          
        }));
        console.log("Fetched certificates:", formattedData);
        
        setCertificates(formattedData);
      }
    } catch (error) {
      console.error("Error fetching certificates:", error);
    } finally {
      setLoading(false);
    }
  };
 
  fetchCertificates();
}, []);
 
  /* ================= DOWNLOAD ================= */
  const handleDownload = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
 
  /* ================= SHARE ================= */
  const handleShareClick = (cert) => {
    console.log("Preparing to share certificate:", cert);
    setShareCert(cert);
  };
 
  const shareLinks = (cert, platform) => {
    let shareUrl = "";
    console.log("Sharing certificate:", cert, "on platform:", platform);
    const encodedTitle = encodeURIComponent("I’ve earned this certificate 🎓");
    const linkedInUrl = encodeURIComponent(cert.publicUrl);
    const imageUrl = encodeURIComponent(cert.image);
 
    switch (platform) {
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${linkedInUrl}`;
        break;
 
      case "whatsapp":
        shareUrl = `https:/api.whatsapp.com/send?text=${encodedTitle}%20${imageUrl}`;
        break;
 
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${imageUrl}`;
        break;
 
      case "gmail":
        shareUrl = `https://mail.google.com/mail/?view=cm&su=${encodedTitle}&body=${imageUrl}`;
        break;
      case "outlook":
        shareUrl = `https://outlook.office.com/mail/deeplink/compose?subject=${encodedTitle}&body=${imageUrl}`;
        break;
      default:
        return;
    }
 
    window.open(shareUrl, "_blank", "noopener,noreferrer");
  };
 
  // ✅ FILTER
  const filteredCertificates = certificates.filter((cert) =>
    cert.title.toLowerCase().includes(searchTerm.toLowerCase()),
  );
 
  // ✅ SORT
  const sortedCertificates = [...filteredCertificates].sort((a, b) => {
    if (sortOption === "name-asc") {
      return a.title.localeCompare(b.title);
    }
    if (sortOption === "name-desc") {
      return b.title.localeCompare(a.title);
    }
    if (sortOption === "date-asc") {
      return new Date(a.dateRaw) - new Date(b.dateRaw);
    }
    if (sortOption === "date-desc") {
      return new Date(b.dateRaw) - new Date(a.dateRaw);
    }
    return 0;
  });
 
  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading certificates...</p>;
  }
 
  return (
    <div className="certificate-section">
      {/* ✅ SEARCH + SORT CONTROLS (PLACED CORRECTLY ABOVE GRID) */}
      {certificates.length > 0 && (
        <div className="cert-controls">
          <input
            type="text"
            placeholder="Search by certificate name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="cert-search"
          />
 
          <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="cert-sort"
          >
            <option value="date-desc">Newest First</option>
            <option value="date-asc">Oldest First</option>
            <option value="name-asc">Name (A-Z)</option>
            <option value="name-desc">Name (Z-A)</option>
          </select>
        </div>
      )}
 
      {certificates.length > 0 ? (
        <div className="certificate-grid">
          {sortedCertificates.map((cert, index) => (
            <div className="certificate-card" key={`${cert.id}-${index}`}>
              <div className="certificate-img">
                <img src={cert.image} alt={cert.title} />
              </div>
 
              <div className="certificate-info">
                <h4>{cert.title}</h4>
                <p>Issued by: {cert.issuedBy}</p>
                <p>Date: {cert.date}</p>
 
                <div className="certificate-actions">
                  <FontAwesomeIcon
                    icon={faEye}
                    className="icon view"
                    onClick={() => setSelectedCert(cert)}
                  />
 
                  <FontAwesomeIcon
                    icon={faDownload}
                    className="icon download"
                    onClick={() => handleDownload(cert.fileUrl)}
                  />
 
                  <FontAwesomeIcon
                    icon={faShareAlt}
                    className="icon share"
                    onClick={() => handleShareClick(cert)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-certificate">
          <div className="empty-card">
            <div className="empty-icon">🎓</div>
            <h2>Your Certificate Awaits</h2>
            <p className="empty-subtitle">
              Complete labs and assessments to earn industry-recognized
              certificates.
            </p>
            <blockquote>
              “Success is the sum of small efforts repeated daily.”
            </blockquote>
            <a
              href="https://www.ssdntech.com/corporate-training"
              target="_blank"
              rel="noopener noreferrer"
              className="btn primary external-link"
            >
              Take Assessment ↗
            </a>
 
 
 
 
 
            <p className="empty-hint">
              Finish your first course to unlock certificates ✨
            </p>
          </div>
        </div>
      )}
 
      {/* ================= VIEW MODAL ================= */}
      {selectedCert && (
        <div className="modal-overlay" onClick={() => setSelectedCert(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <FontAwesomeIcon
              icon={faTimes}
              className="modal-close"
              onClick={() => setSelectedCert(null)}
            />
            <iframe
              src={selectedCert.fileUrl}
              title={selectedCert.title}
              className="certificate-iframe"
            />
          </div>
        </div>
      )}
 
      {/* ================= SHARE MODAL ================= */}
      {shareCert && (
        <div className="modal-overlay-share" onClick={() => setShareCert(null)}>
          <div
            className="modal-content-share"
            onClick={(e) => e.stopPropagation()}
          >
            <FontAwesomeIcon
              icon={faTimes}
              className="modal-close-share"
              onClick={() => setShareCert(null)}
            />
 
            <h4>Share "{shareCert.title}"</h4>
 
            <div className="share-options">
              <img
                src="https://img.icons8.com/color/48/linkedin.png"
                alt="LinkedIn"
                className="icon social"
                onClick={() => shareLinks(shareCert, "linkedin")}
              />
              <img
                src="https://img.icons8.com/color/48/whatsapp.png"
                alt="WhatsApp"
                className="icon social"
                onClick={() => shareLinks(shareCert, "whatsapp")}
              />
              <img
                src="https://img.icons8.com/color/48/facebook-new.png"
                alt="Facebook"
                className="icon social"
                onClick={() => shareLinks(shareCert, "facebook")}
              />
              <img
                src="https://img.icons8.com/color/48/gmail--v1.png"
                alt="Gmail"
                className="icon social"
                onClick={() => shareLinks(shareCert, "gmail")}
              />
              <img
                src="https://img.icons8.com/color/48/microsoft-outlook-2019--v1.png"
                alt="Outlook"
                className="icon social"
                onClick={() => shareLinks(shareCert, "outlook")}
              />
              <img
                src="https://img.icons8.com/fluency/48/link--v1.png"
                alt="Copy Link"
                className="icon social"
                onClick={() => {
                  navigator.clipboard.writeText(shareCert.publicUrl);
                  alert("Certificate page link copied!");
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
 
export default Certificate;